/**
 * MetricCard Component - UX3 Visual Hierarchy
 *
 * Prominent display for key metrics using Von Restorff Effect.
 * Makes important numbers stand out through visual differentiation.
 *
 * Psychology: Von Restorff Effect - distinctive items are more memorable
 * WCAG 2.1 AA compliant with proper contrast ratios.
 */

interface MetricCardProps {
  /** Large number/metric (e.g., "10x", "5x", "30-40") */
  metric: string
  /** Label describing the metric */
  label: string
  /** Optional subtitle/description */
  description?: string
  /** Visual emphasis level */
  emphasis?: 'primary' | 'secondary' | 'accent'
  /** Custom className */
  className?: string
}

export function MetricCard({
  metric,
  label,
  description,
  emphasis = 'primary',
  className = '',
}: MetricCardProps) {
  const classes = [
    'metric-card',
    `metric-card--${emphasis}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes}>
      <div className="metric-card__number">{metric}</div>
      <div className="metric-card__label">{label}</div>
      {description && (
        <div className="metric-card__description">{description}</div>
      )}
    </div>
  )
}

MetricCard.displayName = 'MetricCard'
